<!-- The modal template -->
<div #modal (keydown.enter)="handleKeyPress($event)">
  <div class="modal-header">
    <!-- The modal title -->
    <h4 class="modal-title fw-bolder">
      <i class="fa fa-{{ modalConfig?.icon }} p-1"></i>
      {{ modalConfig.title | translate }}
    </h4>
    <div class="d-flex align-items-center gap-2">
      <button
        *ngFor="let action of modalConfig?.headerActions"
        class="btn btn-outline-primary rounded-pill px-3 py-1"
        (click)="action.callback()"
      >
        <i [class]="action.icon + ' me-1'"></i>
        {{ action.label | translate }}
      </button>
      <span class="dismiss-icon p-2 cursor-pointer" (click)="dismiss()">
        <i class="fa fa-xmark fa-xl"></i>
      </span>
    </div>
  </div>
  <!-- Prefilled-draft notice, shown for create forms that reuse the last entry -->
  <div
    class="row d-flex justify-content-center align-items-center mx-1 mt-2"
    *ngIf="modalConfig?.showDraftNotice"
  >
    <span class="badge bg-info custom-badge fw-bolder">
      <i class="fa fa-circle-info custom-icon py-2"></i>
      {{ 'MODAL.DRAFT_NOTICE' | translate }}
    </span>
  </div>
  <!-- injected body which is a component-->
  <ng-template
    class="modal-body container-fluid"
    #modalBodyContainer
  ></ng-template>
  <div class="modal-footer" *ngIf="hideModalButtons()">
    <!-- Dismiss button -->
    <div class="row justify-content-end">
      <button
        type="button"
        class="col btn btn-pill btn-secondary btn-size m-1"
        (click)="dismiss()"
        *ngIf="
          modalConfig.hideDismissButton === undefined ||
          !modalConfig.hideDismissButton()
        "
        [disabled]="
          modalConfig.disableDismissButton !== undefined &&
          modalConfig.disableDismissButton()
        "
      >
        {{ modalConfig.dismissButtonLabel | translate }}
      </button>
      <!-- Clear button -->
      <button
        type="button"
        class="col btn btn-pill btn-secondary btn-size m-1"
        (click)="clear()"
        *ngIf="modalConfig.hideClearButton && !modalConfig.hideClearButton()"
        [disabled]="
          modalConfig.disableClearButton !== undefined &&
          modalConfig.disableClearButton()
        "
      >
        {{ modalConfig.clearButtonLabel | translate }}
      </button>
      <!-- Close button -->
      <button
        type="button"
        class="col btn btn-pill btn-{{
          modalConfig.closeButtonType ? modalConfig.closeButtonType : 'primary'
        }} btn-size  m-1"
        (click)="close()"
        *ngIf="
          modalConfig.hideCloseButton === undefined ||
          !modalConfig.hideCloseButton()
        "
        [disabled]="
          modalConfig.disableCloseButton !== undefined &&
          modalConfig.disableCloseButton()
        "
      >
        {{ modalConfig.closeButtonLabel | translate }}
      </button>
    </div>
  </div>
</div>
